import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import '../LT/analyticsresults/ViewAllDetails.css';
import Modal from '../../components/common/modal/Modal';
import ButtonComponent from '../../components/common/button/Button';
import { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { getGraphPercentile } from '../../redux/actions/GraphPercentile';
import { getGraphLeadTimeData } from '../../common/endpoints';
import { useDispatch, useSelector } from "react-redux";
import { Loader } from '../../components/common/Loader';

const LeadTimeLineGraph = ({ openLineGraph, data, lineGraphSelectedValue, handleCloseLineGraphModal, handleSaveModal, loading }) => {
    const [axisValue, setAxisValue] = useState({ "leadTime": Math.round(lineGraphSelectedValue?.finalLt), "percentile": lineGraphSelectedValue?.recomConfidenceLevel?.includes("%") ? lineGraphSelectedValue?.recomConfidenceLevel : `${lineGraphSelectedValue?.recomConfidenceLevel}%` })
    useEffect(() => {
        setAxisValue({ "leadTime": Math.round(lineGraphSelectedValue?.finalLt), "percentile": lineGraphSelectedValue?.recomConfidenceLevel?.includes("%") ? lineGraphSelectedValue?.recomConfidenceLevel : `${lineGraphSelectedValue?.recomConfidenceLevel}%` })
    }, [lineGraphSelectedValue, openLineGraph])
    const onChangeAxisPointer = (leadTime, percentile) => {
        setAxisValue({ "leadTime": Math.round(leadTime), "percentile": `${percentile}%` })
    }
    const handleSaveLineGraphModal = () => {
        handleSaveModal(axisValue);
        setAxisValue({})
    }
    const handleCloseGraphModal = () => {
        handleCloseLineGraphModal()
        setAxisValue({})
    }

    return (
        <div>
            <Modal
                className="LeadTimeModal_cls"
                open={openLineGraph}
                handleClose={handleCloseGraphModal}
                title="Recommended Lead Time"
                action={
                    <LeadeTimeFooter
                        className="viewAllDetails_cls"
                        handleCloseModal={handleCloseGraphModal}
                        handleSaveModal={handleSaveLineGraphModal}
                        axisValue={axisValue}
                    />
                }
                content={
                    <LeadTimeContent data={data} loading={loading} onChangeAxisPointer={onChangeAxisPointer} axisValue={axisValue} lineGraphSelectedValue={lineGraphSelectedValue} />
                }
            />
        </div>
    )
}
export default LeadTimeLineGraph;

const LeadTimeContent = ({ onChangeAxisPointer, axisValue, lineGraphSelectedValue }) => {
    const [graphData, setGraphData] = useState([]);
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    useEffect(() => {
        getGraphData()
    }, [])
    const getGraphData = async () => {
        try {
            const responseGraphData = await dispatch(getGraphPercentile({
                dynamicEndpoint: `${getGraphLeadTimeData}/${lineGraphSelectedValue?.runOutputSeqId}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseGraphData.meta.requestStatus === 'fulfilled') {
                setGraphData(responseGraphData?.payload);
            } else {
                toast.error(responseGraphData?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const transformedArray = graphData?.map(([x, y, y2]) => ({ x, y, y2 }));

    const handlePointerMove = (event, d) => {
        onChangeAxisPointer(d.seriesValues["auto-generated-id-0"], Math.round(d.axisValue),)
    };

    return (
        stateSelector?.GraphPercentile?.loading ? <Loader /> :
            <div style={{ width: 700, height: 300, position: "relative" }}>

                {transformedArray.length > 0  && <LineChart
                    dataset={transformedArray}
                    xAxis={[{ dataKey: "x", label: "Percentile" }]}
                    yAxis={[{ dataKey: "y", label: "Lead Time/No. of PO's" }]}
                    series={[
                        { dataKey: "y", label: "Recommended LT", showMark: false },
                        { dataKey: "y2", label: "No. of PO's", color: "red", showMark: false }
                    ]}
                    grid={{ vertical: true, horizontal: true }}
                    onAxisClick={handlePointerMove}
                />}
            </div>
    );
}

const LeadeTimeFooter = ({ handleCloseModal, handleSaveModal, axisValue }) => {
    return (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
            <div style={{ display: 'flex', width: '100%', gap: 20, alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><p>Lead Time: </p><b>{axisValue?.leadTime}</b></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><p>Percentile: </p><b>{axisValue?.percentile}</b></div>
            </div>

            <div className='button-alignment'>
                <ButtonComponent
                    maxWidth="170px"
                    label="Close"
                    type="primary"
                    onClick={handleCloseModal}
                />
                <ButtonComponent
                    maxWidth="170px"
                    label="Save"
                    type="secondary"
                    onClick={handleSaveModal}
                />
            </div>
        </div>
    )
}